<h1>Bronnen</h1>

<p>Hieronder vindt u de volledige bronnenlijst voor de film. Deze is opgemaakt conform het verwijssysteem van de Chicago Manual of Style.</p>

<section class="sources">
  <ol>
    <li>
      Berg, A. Y. van den, and J. A. Inberg. 2008. “Een Soortenlijst van de Biesbosch–oproep Om Mee Te Strepen.” <em>Gorteria Dutch Botanical Archives</em>.
      <a target="_blank" href="https://natuurtijdschriften.nl/pub/537463/GOR2008033003003.pdf">https://natuurtijdschriften.nl/pub/537463/GOR2008033003003.pdf</a>.
    </li>
    <li>
      “Biesbosch.nu.” n.d. Accessed December 13, 2023.
      <a target="_blank" href="http://www.biesbosch.nu/historiepagina.php?code=12">http://www.biesbosch.nu/historiepagina.php?code=12</a>.
    </li>
    <li>
      “Biesbosch verliest getijdenwerking.” n.d. Erfgoedhuis Zuid-Holland. Accessed December 13, 2023. 
      <a target="_blank" href="https://geschiedenisvanzuidholland.nl/verhalen/verhalen/biesbosch-verliest-getijdenwerking/">https://geschiedenisvanzuidholland.nl/verhalen/verhalen/biesbosch-verliest-getijdenwerking/</a>.
    </li>
    <li>
      “Bijvangst: IJsvogel Op de Gevoelige Plaat.” n.d. <em>Sportvisserij Nederland</em> (blog). Accessed July 25, 2023. 
      <a target="_blank" href="https://www.sportvisserijnederland.nl/actueel/nieuws/21508/bijvangst-ijsvogel-op-de-gevoelige-plaat.html">https://www.sportvisserijnederland.nl/actueel/nieuws/21508/bijvangst-ijsvogel-op-de-gevoelige-plaat.html</a>.
    </li>
    <li>
      Blaas, Jan, Leen Rietveld, and Jacques van der Neut. 2014. “Landmeters Blij Met Grenskwesties.” <em>AD De Dordtenaar</em>, July 2, 2014.
    </li>
    <li>
      Bodegraven, Paul van. 2020. “Interview: De Biesbosch Voor En Na de Afsluiting van Het Haringvliet.” <em>De Levende Natuur</em>.
      <a target="_blank" href="https://natuurtijdschriften.nl/pub/1019392">https://natuurtijdschriften.nl/pub/1019392</a>.
    </li>
    <li>
      Boesveld, Arno, and Jacques van der Neut. 1996. “Verspreidbladig Goudveil En Tongvaren in de Biesbosch.” <em>De Levende Natuur</em>.
      <a target="_blank" href="https://natuurtijdschriften.nl/pub/494951/DLN0970110131.pdf">https://natuurtijdschriften.nl/pub/494951/DLN0970110131.pdf</a>.
    </li>
    <li>
      Boxel, John van. 2008. “Signalen van Klimaatveranderingen.” <em>Academia.edu</em>, January.
      <a target="_blank" href="https://www.academia.edu/download/41747792/Signalen_van_klimaatveranderingen20160129-31067-1no5scg.pdf">https://www.academia.edu/download/41747792/Signalen_van_klimaatveranderingen20160129-31067-1no5scg.pdf</a>.
    </li>
    <li>
      “Braakbal van ijsvogel.” n.d. BNNVARA - Vroege vogels. Accessed July 25, 2023. 
      <a target="_blank" href="https://www.bnnvara.nl/vroegevogels/artikelen/braakbal-van-ijsvogel-zelf-geschoten">https://www.bnnvara.nl/vroegevogels/artikelen/braakbal-van-ijsvogel-zelf-geschoten</a>.
    </li>
    <li>
      “Brandgans.” n.d. Vogelbescherming Nederland. Accessed July 23, 2023.
      <a target="_blank" href="https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/brandgans">https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/brandgans</a>.
    </li>
    <li>
      “Broedende visarenden in de Biesbosch ook dit jaar weer live te volgen.” 2023. Vogelbescherming Nederland. March 19, 2023.
      <a target="_blank" href="https://www.vogelbescherming.nl/actueel/bericht/broedende-visarenden-in-de-biesbosch-ook-dit-jaar-weer-live-te-volgen">https://www.vogelbescherming.nl/actueel/bericht/broedende-visarenden-in-de-biesbosch-ook-dit-jaar-weer-live-te-volgen</a>.
    </li>
    <li>
      “Bruine kiekendief.” n.d. Vogelbescherming Nederland. Accessed July 25, 2023.
      <a target="_blank" href="https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/bruine-kiekendief">https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/bruine-kiekendief</a>.
    </li>
    <li>
      Buisman, J. 1995. <em>Duizend jaar weer, wind en water in de Lage Landen: Tot 1300.</em> Van Wijnen.
    </li>
    <li>
      Bureau Noordwaard, Rijkswaterstaat. 2006. “Ontpoldering Noordwaard Startnotitie MER.”
    </li>
    <li>
      De Minister van Landbouw, Natuur en Voedselkwaliteit. n.d. <em>Ontwerpbesluit Biesbosch</em>.
      <a target="_blank" href="https://www.natura2000.nl/sites/default/files/gebieden_aanwijzing_en_archief/112/n2k112_wb_hrvr_biesbosch.pdf">https://www.natura2000.nl/sites/default/files/gebieden_aanwijzing_en_archief/112/n2k112_wb_hrvr_biesbosch.pdf</a>.
    </li>
    <li>
      De Vries, J. M. 2000. “Ruimte Voor de Rivier: Discussienota.” <em>Nota van de Staatssecretaris</em>.
      <a target="_blank" href="https://repository.tudelft.nl/islandora/object/uuid:cbfc7575-6e6d-4b77-bdae-025fe34badba">https://repository.tudelft.nl/islandora/object/uuid:cbfc7575-6e6d-4b77-bdae-025fe34badba</a>.
    </li>
    <li>
      Esch, J. M. van der. 2005. <em>Tussen bies en wilg: over kooikers, otterjagers en biezensnijders in de oude Biesbosch.</em> De Stroombaan.
    </li>
    <li>
      “Ganzen horen bij Nederland.” n.d. Staatsbosbeheer. Accessed July 23, 2023.
      <a target="_blank" href="https://www.staatsbosbeheer.nl/wat-we-doen/flora-en-fauna/ganzen">https://www.staatsbosbeheer.nl/wat-we-doen/flora-en-fauna/ganzen</a>.
    </li>
    <li>
      Garjeanne. 1908. “Een Nieuwe Lythracee Voor de Nederlandsche Flora.” <em>De Levende Natuur</em>.
      <a target="_blank" href="https://natuurtijdschriften.nl/pub/486206/DLN0131241267.pdf">https://natuurtijdschriften.nl/pub/486206/DLN0131241267.pdf</a>.
    </li>
    <li>
      “Groep Reeën.” 2017. Het Ree. Vereniging Het Ree. March 19, 2017.
      <a target="_blank" href="https://hetree.nl/groep-reeen/">https://hetree.nl/groep-reeen/</a>.
    </li>
    <li>
      “Haas.” n.d. De Zoogdiervereniging. Accessed March 9, 2022.
      <a target="_blank" href="https://www.zoogdiervereniging.nl/zoogdiersoorten/haas">https://www.zoogdiervereniging.nl/zoogdiersoorten/haas</a>.
    </li>
    <li>
      Ham, Willem van der. 2003. <em>De Grote Waard: geschiedenis van een Hollands landschap</em>. Uitgeverij 010.
    </li>
    <li>
      “Het verschil tussen een man en vrouw ijsvogel.” n.d. BNNVARA - Vroege vogels. Accessed July 25, 2023. 
      <a target="_blank" href="https://www.bnnvara.nl/vroegevogels/artikelen/het-verschil-tussen-een-man-en-vrouw-ijsvogel">https://www.bnnvara.nl/vroegevogels/artikelen/het-verschil-tussen-een-man-en-vrouw-ijsvogel</a>.
    </li>
    <li>
      “Historie – Nationaal Park De Biesbosch.” n.d. Nationaal Park De Biesbosch. Accessed March 17, 2022.
      <a target="_blank" href="https://np-debiesbosch.nl/de-biesbosch/historie/">https://np-debiesbosch.nl/de-biesbosch/historie/</a>.
    </li>
    <li>
      Hollander, Hans. 2017. “Hazen in de voortplanting: rammelen!” De Zoogdiervereniging. March 16, 2017. 
      <a target="_blank" href="https://www.zoogdiervereniging.nl/nieuws/2017/hazen-de-voortplanting-rammelen">https://www.zoogdiervereniging.nl/nieuws/2017/hazen-de-voortplanting-rammelen</a>.
    </li>
    <li>
      Kimstra, and Kimstra. 2016. “Arenden in de Biesbosch.” <em>Natura</em>.
      <a target="_blank" href="https://natuurtijdschriften.nl/pub/641927/Natura2016113003001.pdf">https://natuurtijdschriften.nl/pub/641927/Natura2016113003001.pdf</a>.
    </li>
    <li>
      “Klissen geen probleem voor dierenwelzijn.” n.d. Accessed December 13, 2023. 
      <a target="_blank" href="https://www.freenature.nl/nieuws/2018/klissen-geen-probleem-voor-dierenwelzijn">https://www.freenature.nl/nieuws/2018/klissen-geen-probleem-voor-dierenwelzijn</a>.
    </li>
    <li>
      Knoester, M., H. Oosterwijk, T. Pietersz, and A. Prakken. n.d. “Geheimen van de Kust.” Accessed April 23, 2022.
      <a target="_blank" href="https://www.researchgate.net/profile/Rwpm-Laane-rip-2/publication/277665143_Geheimen_van_de_kust/links/556f500a08aec226830a8bd8/Geheimen-van-de-kust.pdf">https://www.researchgate.net/profile/Rwpm-Laane-rip-2/publication/277665143_Geheimen_van_de_kust/links/556f500a08aec226830a8bd8/Geheimen-van-de-kust.pdf</a>.
    </li>
    <li>
      “Kolgans.” 2015. De Jagersvereniging. May 31, 2015.
      <a target="_blank" href="https://www.jagersvereniging.nl/jagen/diersoorten/kolgans/">https://www.jagersvereniging.nl/jagen/diersoorten/kolgans/</a>.
    </li>
    <li>
      ———. n.d. Vogelbescherming Nederland. Accessed July 23, 2023.
      <a target="_blank" href="https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/kolgans.">https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/kolgans.</a>.
    </li>
    <li>
      Lensink R., van den Bergh L. M. J. &. Voslamber B. 2013. “De geschiedenis van de Grauwe Gans als Nederlandse broedvogel in de 20e eeuw.” <em>Limosa</em>.
      <a target="_blank" href="https://pub.sovon.nl/pub/publicatie/18308">https://pub.sovon.nl/pub/publicatie/18308</a>.
    </li>
    <li>
      “Meerkoet.” n.d. Vogelbescherming Nederland. Accessed July 25, 2023.
      <a target="_blank" href="https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/meerkoet">https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/meerkoet</a>.
    </li>
    <li>
      Nationaal Park de Biesbosch, Staatsbosbeheer, and Streekfonds Streeknetwerk Biesbosch. 2015. “WATER in En Om de Biesbosch - Docentenhandleiding.” 
      <a target="_blank" href="https://np-debiesbosch.nl/wp-content/uploads/2015/06/WATER-lesbrief-leerkracht.pdf">https://np-debiesbosch.nl/wp-content/uploads/2015/06/WATER-lesbrief-leerkracht.pdf</a>.
    </li>
    <li>
      Natura 2000-Ministerie van Landbouw, Natuur en Voedselkwaliteit. 2008. “Profielen Vogels - Porseleinhoen.”
    </li>
    <li>
      Neut, Jacques van der. 2018. “Futen vechten in de Biesbosch om een territorium.” AD. September 14, 2018.
      <a target="_blank" href="https://www.ad.nl/rivierenland/futen-vechten-in-de-biesbosch-om-een-territorium~ac0b9c38/">https://www.ad.nl/rivierenland/futen-vechten-in-de-biesbosch-om-een-territorium~ac0b9c38/</a>.
    </li>
    <li>
      Nolet, and Hoekstra. 1990. “Het Eerste Jaar Na Uitzetting Bevers in de Biesbosch.” <em>Zoogdier</em>.
      <a target="_blank" href="https://natuurtijdschriften.nl/pub/589432">https://natuurtijdschriften.nl/pub/589432</a>.
    </li>
    <li>
      Overland, in opdracht van De Bastei, Nijmegen. . n.d. “De bijna-ramp 1995.” Mijn Gelderland. Accessed November 7, 2022. 
      <a target="_blank" href="https://mijngelderland.nl/inhoud/specials/verbeelding-van-de-waal/de-bijna-ramp-1995">https://mijngelderland.nl/inhoud/specials/verbeelding-van-de-waal/de-bijna-ramp-1995</a>.
    </li>
    <li>
      Rijkswaterstaat. n.d. “De Deltawerken.” Rijkswaterstaat.nl. Accessed August 15, 2022.
      <a target="_blank" href="https://www.rijkswaterstaat.nl/water/waterbeheer/bescherming-tegen-het-water/waterkeringen/deltawerken">https://www.rijkswaterstaat.nl/water/waterbeheer/bescherming-tegen-het-water/waterkeringen/deltawerken</a>.
    </li>
    <li>
      Schenk, Dorine. 2019. “Bijen surfen op zelfgemaakte golven naar de waterkant.” New Scientist. November 28, 2019. 
      <a target="_blank" href="https://www.newscientist.nl/nieuws/bijen-surfen-op-zelfgemaakte-golven-naar-de-waterkant/">https://www.newscientist.nl/nieuws/bijen-surfen-op-zelfgemaakte-golven-naar-de-waterkant/</a>.
    </li>
    <li>
      Schiereck, G. J., and P. J. Visser. 2021. “De Sint-Elisabethsvloed: Feiten En Fictie.” <em>Vloed: De Sint-Elisabethsvloed 1421 ….</em>
      <a target="_blank" href="https://research.tudelft.nl/en/publications/de-sint-elisabethsvloed-feiten-en-fictie">https://research.tudelft.nl/en/publications/de-sint-elisabethsvloed-feiten-en-fictie</a>.
    </li>
    <li>
      Sovon Vogelonderzoek Nederland. n.d. “Porseleinhoen.” Accessed December 13, 2023.
      <a target="_blank" href="https://stats.sovon.nl/stats/soort/4080">https://stats.sovon.nl/stats/soort/4080</a>.
    </li>
    <li>
      Staatsbosbeheer. n.d. “Over de Biesbosch.” Staatsbosbeheer. Accessed 2 maart 2022. 
      <a target="_blank" href="https://www.staatsbosbeheer.nl/uit-in-de-natuur/locaties/biesbosch/over-de-biesbosch">https://www.staatsbosbeheer.nl/uit-in-de-natuur/locaties/biesbosch/over-de-biesbosch</a>.
    </li>
    <li>
      “Turf.” n.d. Canon van Nederland. Accessed April 23, 2022.
      <a target="_blank" href="https://www.canonvannederland.nl/nl/utrecht/onderwijscanon/turf">https://www.canonvannederland.nl/nl/utrecht/onderwijscanon/turf</a>.
    </li>
    <li>
      Verhey, C. J. 1950. “De Biesbosch in Gevaar!” <em>De Levende Natuur</em> 53 (10): 181–88.
    </li>
    <li>
      “Visarend.” n.d. Vogelbescherming Nederland. Accessed July 25, 2023.
      <a target="_blank" href="https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/visarend">https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/visarend</a>.
    </li>
    <li>
      Vogelbescherming Nederland. n.d. “Blauwe reiger.” Accessed November 16, 2022a.
      <a target="_blank" href="https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/blauwe-reiger.">https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/blauwe-reiger.</a>.
    </li>
    <li>
      ———. n.d. “Grote zilverreiger.” Accessed November 16, 2022b.
      <a target="_blank" href="https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/grote-zilverreiger">https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/grote-zilverreiger</a>.
    </li>
    <li>
      ———. n.d. “Kleine zilverreiger.” Accessed November 16, 2022c.
      <a target="_blank" href="https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/kleine-zilverreiger">https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/kleine-zilverreiger</a>.
    </li>
    <li>
      ———. n.d. “Koereiger.” Accessed November 16, 2022d.
      <a target="_blank" href="https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/koereiger">https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/koereiger</a>.
    </li>
    <li>
      ———. n.d. “Lepelaar.” Accessed November 3, 2022e.
      <a target="_blank" href="https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/lepelaar">https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/lepelaar</a>.
    </li>
    <li>
      ———. n.d. “Sperwer.” Accessed November 16, 2022f.
      <a target="_blank" href="https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/sperwer">https://www.vogelbescherming.nl/ontdek-vogels/kennis-over-vogels/vogelgids/vogel/sperwer</a>.
    </li>
    <li>
      “Voortplanting - IJsvogels.nl.” 2014. IJsvogels.nl - Alles over ijsvogels. IJsvogels.nl. July 17, 2014.
      <a target="_blank" href="https://www.ijsvogels.nl/voortplanting-2/">https://www.ijsvogels.nl/voortplanting-2/</a>.
    </li>
    <li>
      Wijk, Wim van. 2009. <em>Het Biesbosch boek</em>. Waanders Uitgeverij.
    </li>
    <li>
      ———. 2021. Biesbosch en Haringvliet: natuur van wereldklasse. WBOOKS.
    </li>
    <li>
      Zingstra. 1997. “De Biesbosch Breidt Uit.” <em>De Levende Natuur</em>.
      <a target="_blank" href="https://natuurtijdschriften.nl/pub/495017/DLN0980610682.pdf">https://natuurtijdschriften.nl/pub/495017/DLN0980610682.pdf</a>.
    </li>
  </ol>
</section>

<style>
  .sources > ol {
    list-style: none;
  }

  .sources > ol > li {
    text-indent: -4rem;
    margin-left: 4rem;
  }

  .sources > ol > li > a {
    overflow-wrap: break-word;
  }
</style>